import { render, staticRenderFns } from "./NavigationSubLinks.vue?vue&type=template&id=1c059ed2&scoped=true&"
import script from "./NavigationSubLinks.vue?vue&type=script&lang=js&"
export * from "./NavigationSubLinks.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSubLinks.vue?vue&type=style&index=0&id=1c059ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c059ed2",
  null
  
)

export default component.exports